// extracted by mini-css-extract-plugin
export default {"title-user":"MyBookPrint_title-user__oinB3"};